module.exports = __webpack_public_path__ + "static/img/game_pic_example.e81f409.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game_pic_example.png
// module id = hV9W
// module chunks = 1